import { URL, APP_SITE_URL } from '../constants';

// When we last sent the browser to login, cleared once a call actually authenticates.
const LOGIN_ATTEMPT_KEY = `smartrak-login-attempt`;

// Long enough to cover the round trip through login.aspx and back. After this a 401 is treated as a new
// problem (e.g. the user backed out of the login page) and gets another trip to login.
const LOGIN_ATTEMPT_WINDOW_MS = 60 * 1000;

// Returns false when we have just been to login and come back still unauthorised. Logging in
// again cannot help in that state, and login.aspx sends an authenticated user straight back here,
// so redirecting a second time loops until the tab is closed. Callers show an error instead.
export const toLogin = () => {
    if (Date.now() - Number(sessionStorage.getItem(LOGIN_ATTEMPT_KEY)) < LOGIN_ATTEMPT_WINDOW_MS)
        return false;

    sessionStorage.setItem(LOGIN_ATTEMPT_KEY, Date.now());
    window.location = `${APP_SITE_URL}/login.aspx?ReturnUrl=${encodeURIComponent(`${URL}/loggedin`)}&site=poolbooking`;
    return true;
};

// Call once something has authenticated, so a later session expiry can redirect to login again.
export const loginSucceeded = () => sessionStorage.removeItem(LOGIN_ATTEMPT_KEY);

export const toLogOut = () => window.location = `${APP_SITE_URL}/Logout.aspx?ReturnUrl=${encodeURIComponent(URL)}`;



// WEBPACK FOOTER //
// ./scripts/services/navigate.js